import type { CanvasFrame } from "@refinement-canvas/domain";
import { CANVAS_HEIGHT_PX, CANVAS_WIDTH_PX } from "./canvas-coordinates";

// ペン入力プレビュー用 Canvas が覆うべき矩形（ステージ座標）を求める。
//
// キャンバス外にも配置可という当初仕様へ戻したため、ペンの確定ストローク自体はキャンバス矩形の
// 外側でも通る。一方で入力中プレビューはこの矩形の中にしか描けないと、矩形の外から描き始めた
// ストロークが pointerup まで見えず、確定時に突然現れる回帰になる。
//
// これを防ぐため、プレビュー矩形は「固定ステージ（原点 0,0・CANVAS_WIDTH_PX × CANVAS_HEIGHT_PX）」と
// 「現在のキャンバスサイズ矩形」の和集合とする。これにより次のいずれも確定前から可視化できる。
//  - 小 / 中サイズで、キャンバス矩形の外側（ただしステージ内）から描き始めたストローク
//  - 大サイズで、キャンバス矩形がステージ外へ張り出した領域に描いたストローク
export function resolvePenPreviewRect(canvasRect: CanvasFrame): CanvasFrame {
  const minX = Math.min(0, canvasRect.x);
  const minY = Math.min(0, canvasRect.y);
  const maxX = Math.max(CANVAS_WIDTH_PX, canvasRect.x + canvasRect.w);
  const maxY = Math.max(CANVAS_HEIGHT_PX, canvasRect.y + canvasRect.h);
  return { x: minX, y: minY, w: maxX - minX, h: maxY - minY };
}
